/**
 * Route paths for the company feature. The same strings are the sidebar menu keys
 * in `useMenuCompany`, so they must stay absolute: the detail view runs
 * `matchPath` and `generatePath` against them.
 */
export const COMPANY_ROUTES = {
  companies: "/companies",
  add: "/companies/add",
  companyDetail: "/companies/:companyId",

  general: "/companies/:companyId/general",
  generalInfo: "/companies/:companyId/general/info",
  banks: "/companies/:companyId/general/banks",
  bankAccounts: "/companies/:companyId/general/banks/:bankId/bank-accounts",
  bankAccountCreate: "/companies/:companyId/general/banks/:bankId/bank-accounts/create",
  bankAccount: "/companies/:companyId/general/banks/:bankId/bank-accounts/:bankAccountId",
  addresses: "/companies/:companyId/general/addresses",
  assignments: "/companies/:companyId/general/assignments",

  legal: "/companies/:companyId/legal",
  legalInfo: "/companies/:companyId/legal/info",
  tax: "/companies/:companyId/legal/tax",
  vat: "/companies/:companyId/legal/vat",
  legalDirectors: "/companies/:companyId/legal/directors",
  legalStakeholders: "/companies/:companyId/legal/stakeholders",
  obligations: "/companies/:companyId/legal/obligations",

  clients: "/companies/:companyId/clients",

  accounting: "/companies/:companyId/accounting",
  accountingGeneralConstants: "/companies/:companyId/accounting/general-constants",
  accountingGeneralCycles: "/companies/:companyId/accounting/cycles",
  accountingBooks: "/companies/:companyId/accounting/books",
  accountingVats: "/companies/:companyId/accounting/vats",
  accountingClients: "/companies/:companyId/accounting/clients",
  accountingProviders: "/companies/:companyId/accounting/providers",
  accountingCounterparts: "/companies/:companyId/accounting/counterparts",
  accountingSubsidiaries: "/companies/:companyId/accounting/subsidiaries",
  accountingCustomGraphics: "/companies/:companyId/accounting/custom-graphics",
  accountingKeywords: "/companies/:companyId/accounting/keywords",
  accountingExpensesCategories: "/companies/:companyId/accounting/expenses-categories",
  accountingImport: "/companies/:companyId/accounting/import",
  accountingExport: "/companies/:companyId/accounting/export",

  accountingBalanceReview: "/companies/:companyId/accounting-balance-review",
  settings: "/companies/:companyId/settings",

  fileProgress: "/companies/:companyId/file-progress",
  fileProgressMl: "/companies/:companyId/file-progress/ml-progress",
  fileProgressSsi: "/companies/:companyId/file-progress/ssi-progress",
  fileProgressHistory: "/companies/:companyId/file-progress/history-progress",
} as const;
